import { makeStyles } from "@material-ui/core";
import { colors } from "@utils/constant";

const BackDatedEventsStyle = makeStyles({
  innerPageTopBlock: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 1359px)": {
      flexWrap: "wrap",
    },
    "& h1": {
      fontSize: "30px",
      color: colors.black,
      textTransform: "capitalize",
      margin: "0 20px 0 0",
    },
    "& .right-block": {
      flex: "1",
      "& .right-block-inner": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "15px",
        "& button": {
          whiteSpace: "nowrap",
          padding: "0 50px",
        },
        "@media (max-width: 1300px)": {
          flexWrap: "wrap",
        },
        "@media (max-width: 574px)": {
          justifyContent: "center",
          "& button": {
            whiteSpace: "normal",
            height: "auto"
          },
        },
      },
    },
    "& .left-block": {
      paddingRight: "10px",
      "@media (max-width: 1359px)": {
        maxWidth: "100%",
        padding: "0px",
      },
    },
  },
});

export { BackDatedEventsStyle };
